import {
    inject,
    Injectable
} from '@angular/core';

import {
    HttpClient
} from '@angular/common/http';

import {
    Observable
} from 'rxjs';

import {
    environment
} from '../../../../environments/environment';

import {
    MyRestaurantResponse
} from '../models/my-restaurant-response';


@Injectable({
    providedIn: 'root'
})
export class RestaurantService {

    private readonly http =
        inject(HttpClient);


    private readonly baseUrl =
        environment.restaurantApiUrl;


    getMyRestaurants():
        Observable<MyRestaurantResponse[]> {

        return this.http.get<
            MyRestaurantResponse[]
        >(
            `${this.baseUrl}/api/v1/restaurants/my`
        );
    }
}